/**
 * @generated SignedSource<<35588b02cc21a3b18228280a5a8d05de>>
 * @relayHash 8f92b2b794a58ab706ee9a0fb9f74f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a97c50980e598914f8237cff2ccad6c06e91f48ba80f19340231dccbe6be6fd5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_timelineQuery } from './src_timelineQuery.graphql';

import isRemoveFieldOptionsEnabled_provider from '@atlassian/jira-relay-provider/src/empanada-remove-field-options.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isSavedListViewTechnicalChangesDogfoodingEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-dogfooding-enabled.relayprovider';
import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isIssueRealtimeExtractionEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-realtime-extraction.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isQueryByStatusFieldDirectlyEnabled_provider from '@atlassian/jira-relay-provider/src/jiv-20953-query-by-status-field-directly.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';

const node: PreloadableConcreteRequest<src_timelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a97c50980e598914f8237cff2ccad6c06e91f48ba80f19340231dccbe6be6fd5",
    "metadata": {},
    "name": "src_timelineQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": isIssueRealtimeExtractionEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": isQueryByStatusFieldDirectlyEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": isRemoveFieldOptionsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider": isSavedListViewTechnicalChangesDogfoodingEnabled_provider
    }
  }
};

export default node;
